import React from 'react';
import { TextField } from '@material-ui/core';
import { Field } from 'formik';

export const ReportTextField = ({ name, label, component, ...rest }) => {
  return (
    <Field
      as={!component && TextField}
      name={name}
      label={label}
      fullWidth
      component={component}
      {...rest}
      variant="outlined"
    />
  );
};